import React from "react";
import styles from "./checkbox.module.css";
import { MyIcons } from "../../icons/my-icons";

const Checkbox = ({
  label,
  checked = false,
  color = "#CDA16A",
  onChange,
  style,
}) => {
  return (
    <div
      className={styles.checkboxContainer}
      style={style}
      onClick={() => onChange && onChange(!checked)}
    >
      <div
        className={`${styles.checkbox} ${checked ? styles.checked : ""}`}
        style={{
          borderColor: color,
          background: checked ? color : "#fff",
          transition: "background 0.2s, border 0.2s",
        }}
      >
        {checked && <MyIcons name={"check"} color="#fff" />}
      </div>
      {label && <label className={styles.label}>{label}</label>}
    </div>
  );
};

export default Checkbox;